import data from "emoji-mart-vue/data/all.json";

export const emojis = Object.keys(data.emojis);
